import React from "react";
import WaterMap from './map/Map';

export default function FloodDay() {
    return <>
        <WaterMap />
    </>;
}